// extracted by mini-css-extract-plugin
module.exports = {"Comment":"Feedback_Comment__8mcY-","text":"Feedback_text__35cU3"};